export default __webpack_public_path__ + "static/logo4-7c78bb32fd6e8f99cb4e65e79c08212f.png";